import gql from "graphql-tag";

export const QuoteByGuid = gql `
  query quoteByGuid($guid: String!,$token:String!) {
    QuoteByGuid(guid: $guid,token:$token) {
      id,
      description,
      sq_taskguid,
      fk_clientID,
      fk_userId,
      benefits,
      date_created,
      date_created,
      fullName,
      values,
      desc
    }
  }
`;


// WEBPACK FOOTER //
// ./src/queries/quotesByBroker.js